if (!customElements.get('nss-bundles')) {
  customElements.define(
    'nss-bundles',
    class NSSBundles extends HTMLElement {
      connectedCallback() {
        this.trigger     = this.querySelector('.nss-bundles__trigger');
        this.triggerLabel = this.querySelector('.nss-bundles__trigger-label');
        this.optionsList  = this.querySelector('.nss-bundles__options');
        this.options      = this.querySelectorAll('.nss-bundles__option');
        this.panels       = this.querySelectorAll('.nss-bundles__panel');

        this.trigger?.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggleDropdown();
        });

        this.options.forEach((option) => {
          option.addEventListener('click', () => {
            this.selectOption(option);
            this.closeDropdown();
          });
        });

        document.addEventListener('click', (e) => {
          if (!this.contains(e.target)) this.closeDropdown();
        });

        // Escape key closes dropdown
        this.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') this.closeDropdown();
        });

        // Select first option on init
        if (this.options[0]) this.selectOption(this.options[0]);
      }

      toggleDropdown() {
        const isOpen = this.trigger.getAttribute('aria-expanded') === 'true';
        isOpen ? this.closeDropdown() : this.openDropdown();
      }

      openDropdown() {
        this.trigger.setAttribute('aria-expanded', 'true');
        this.optionsList.classList.add('is-open');
      }

      closeDropdown() {
        this.trigger.setAttribute('aria-expanded', 'false');
        this.optionsList.classList.remove('is-open');
      }

      selectOption(option) {
        const productId = option.dataset.productId;

        // Update trigger label
        this.triggerLabel.textContent = option.textContent.trim();

        // Mark option active
        this.options.forEach((o) => {
          o.classList.toggle('is-selected', o === option);
          o.setAttribute('aria-selected', o === option ? 'true' : 'false');
        });

        // Show matching panel
        this.panels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.productId === productId);
        });

        // Update .js-bundle-image elements in the section
        const activePanel = [...this.panels].find(p => p.dataset.productId === productId);
        const imageUrl    = activePanel?.dataset.bundleImage;
        const imageSrcset = activePanel?.dataset.bundleImageSrcset;
        if (imageUrl) {
          const section = this.closest('.shopify-section');
          (section || document).querySelectorAll('.js-bundle-image').forEach(img => {
            img.src = imageUrl;
            if (imageSrcset) img.srcset = imageSrcset;
          });
        }
      }
    }
  );
}
